import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import defaultAvatar from '@/assets/icons/default-avatar/default-avatar.svg'
import { useUserContext } from '@/contexts/user/useUserContext'
import { updateUserProfile } from '@/services/persea-user/update-user/update-user'
import { 
    RegisterCardContainer, 
    RegisterCardTitle, 
    RegisterCardBody,
    RegisterCardInputContainer,
    RegisterCardLabel,
    RegisterCardInput
} from './style-component'
import { ProfilePicture } from '../profile-picture/profile-picture'
import CustomButton from '../custom-button/custom-button'
import { Typography } from 'antd'

export const RegisterCard = () => {
    const [profilePicture, setProfilePicture] = useState(defaultAvatar)
    const [username, setUsername] = useState('')
    const [error, setError] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const navigate = useNavigate()
    const { user, setUser } = useUserContext()

    const handleUsernameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value
        if (value.length <= 20) {
            setUsername(value)
            if (value.length > 0 && value.length < 3) {
                setError('El nombre debe tener al menos 3 caracteres')
            } else {
                setError('')
            }
        } else {
            setError('El nombre no puede tener más de 20 caracteres')
        }
    }

    const handleSubmit = async () => {
        if (!username.trim()) {
            setError('El nombre es obligatorio')
            return
        }
        if (username.length < 3) {
            setError('El nombre debe tener al menos 3 caracteres')
            return
        }
        try {
            setIsLoading(true)
            
            try {
                await updateUserProfile({
                    wallet: user?.main_key ?? '',
                    username: username, 
                    email: user?.email ?? '',
                    wallet_pic_url: profilePicture !== defaultAvatar ? profilePicture : user?.wallet_pic_url ?? ''
                })
            } catch (apiError) {
                console.error('API Error:', apiError)
                setError('Error al actualizar el perfil')
                // THIS WILL BE REMOVED WHEN THE API IS FIXED
            }

            if (user) {
                setUser({
                    ...user,
                    username,
                    wallet_pic_url: profilePicture,
                    address: user.address ?? '',
                    main_key: user.main_key ?? '',
                    email: user.email ?? '',
                    balance: user.balance ?? 0
                })
            }
            
            localStorage.removeItem('isNewUser')
            navigate('/home')
        } catch (error) {
            console.error('Error in handleSubmit:', error)
            // THIS WILL BE REMOVED WHEN THE API IS FIXED
            localStorage.removeItem('isNewUser')
            navigate('/home')
        } finally {
            setIsLoading(false)
        }
    }

    const handleProfilePictureChange = (imageUrl: string) => {
        setProfilePicture(imageUrl)
    }

    const handleOmit = () => {
        localStorage.removeItem('isNewUser')
        navigate('/home')
    }

    const isValidUsername = username.trim().length >= 3 && username.length <= 20

    return (
        <RegisterCardContainer>
            <RegisterCardTitle>Completa tus datos</RegisterCardTitle>
            <RegisterCardBody>
                <ProfilePicture 
                    initialImage={profilePicture}
                    onImageChange={handleProfilePictureChange}
                />
                <RegisterCardInputContainer>
                    <RegisterCardLabel>Nombre</RegisterCardLabel>
                    <RegisterCardInput 
                        type="text" 
                        placeholder="Ingresa tu nombre de usuario" 
                        value={username}
                        onChange={handleUsernameChange}
                        maxLength={20}
                    />
                    {error && <span style={{ color: 'red', fontSize: '12px' }}>{error}</span>}
                </RegisterCardInputContainer>
                <CustomButton 
                    onClick={handleSubmit} 
                    disabled={!isValidUsername || isLoading}
                >
                    {isLoading ? 'Actualizando...' : 'Guardar'}
                </CustomButton>
                <button
                    style={{
                        backgroundColor: 'transparent',
                        border: 'none',
                        cursor: 'pointer',
                        boxShadow: 'none',
                    }}
                    onClick={handleOmit} 
                    disabled={isLoading}
                >
                    <Typography.Text>Omitir</Typography.Text>
                </button>
            </RegisterCardBody>
        </RegisterCardContainer>
    )
}
